import React from "react";
import { Link } from "react-router-dom";
import "./PageHeader.css";

export interface BreadcrumbItem {
  label: string;
  href?: string;
}

export interface PageHeaderProps {
  title: string;
  subtitle?: string;
  actions?: React.ReactNode;
  breadcrumbs?: BreadcrumbItem[];
  className?: string;
}

const PageHeader: React.FC<PageHeaderProps> = ({
  title,
  subtitle,
  actions,
  breadcrumbs,
  className = "",
}) => {
  return (
    <div className={`page-header ${className}`} data-testid="page-header">
      {breadcrumbs && breadcrumbs.length > 0 && (
        <div className="page-breadcrumbs" aria-label="breadcrumbs">
          {breadcrumbs.map((crumb, index) => (
            <React.Fragment key={`${crumb.label}-${index}`}>
              {index > 0 && <span className="breadcrumb-separator">/</span>}
              {crumb.href ? (
                <Link to={crumb.href} className="breadcrumb-link">
                  {crumb.label}
                </Link>
              ) : (
                <span className="breadcrumb-current">{crumb.label}</span>
              )}
            </React.Fragment>
          ))}
        </div>
      )}

      <div className="page-header-content">
        <div className="page-header-titles">
          <h1 className="page-title">{title}</h1>
          {subtitle && <h2 className="page-subtitle">{subtitle}</h2>}
        </div>

        {actions && <div className="page-header-actions">{actions}</div>}
      </div>
    </div>
  );
};

export default PageHeader;
